import React from 'react';
import { Palette, Users, TrendingUp, Award } from 'lucide-react';

const DesignSection = () => {
  const designImages = [
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/vfeil0n2_IMG_3123.jpeg',
      alt: 'SESAM - Votre visibilité, notre priorité'
    },
    {
      id: 2,
      url: 'https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/d2j01gya_IMG_3110.jpeg',
      alt: 'Panneaux SESAM - Innovant, Dynamique, Impactant'
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/rx3db6a0_IMG_3109.jpeg',
      alt: 'Je choisis SESAM pour ma visibilité'
    },
    {
      id: 4,
      url: 'https://customer-assets.emergentagent.com/job_crm-showcase-5/artifacts/pq104mb3_IMG_3120.jpeg',
      alt: 'Exemple de conception SESAM'
    }
  ];

  const features = [
    {
      icon: Palette,
      title: 'Expertise Design',
      description: 'Designers professionnels expérimentés'
    },
    {
      icon: Users,
      title: 'Artistes Locaux',
      description: 'Collaboration avec talents centrafricains'
    },
    {
      icon: TrendingUp,
      title: 'Visibilité Optimisée',
      description: 'Supports adaptés à votre projet'
    },
    {
      icon: Award,
      title: 'Impact Authentique',
      description: 'Créations pertinentes et culturelles'
    }
  ];

  return (
    <section id="conception" className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl mb-6 shadow-lg">
            <Palette className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Conception Graphique
          </h2>
          <p className="text-lg sm:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            SESAM vous accompagne dans la conception de vos images grâce à l'expertise de nos designers. 
            Nous vous aidons à collaborer avec des artistes locaux afin de créer un impact authentique et pertinent. 
            En choisissant les supports les plus adaptés, nous optimisons également la visibilité de vos visuels 
            pour valoriser au mieux votre projet.
          </p>
        </div>

        {/* Grille de fonctionnalités */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-purple-200"
              >
                <div className="bg-gradient-to-br from-purple-100 to-pink-100 w-14 h-14 rounded-xl flex items-center justify-center mb-4">
                  <Icon className="w-7 h-7 text-purple-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Galerie d'exemples */}
        <div className="mb-12">
          <h3 className="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-8">
            Exemples de nos créations
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            {designImages.map((image) => (
              <div 
                key={image.id}
                className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 bg-white"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-white font-semibold text-lg">
                      {image.alt}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesignSection;
